import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
export var reduxModuleLoaded = createAction("".concat(actionKey, ".REDUX_READY"), function () { return ({}); });
export var subscribeToTier = createAction("".concat(actionKey, ".SUBSCRIBE_TO_TIER"), function (tier) { return ({ tier: tier }); });
export var pushUnsubscribeModal = function (tier) {
    return pushModal(ModalType.TIER_UNSUBSCRIBE, {
        params: { tier: tier },
        wrapInModal: false,
    });
};
export var pushUnsubscribeModalByUsername = function (username) {
    return pushModal(ModalType.TIER_UNSUBSCRIBE_BY_USERNAME, {
        params: { username: username },
        wrapInModal: false,
    });
};
export var unsubRequestByUsername = createAction("".concat(actionKey, ".UNSUBSCRIBE_REQUEST_BY_USERNAME"), function (username) { return ({ username: username }); });
export var unsubRequest = createAction("".concat(actionKey, ".UNSUBSCRIBE_REQUEST"), function (tier) { return ({ tier: tier }); });
export var overrideSubscribeMatureFilter = createAction("".concat(actionKey, ".OVERRIDE_SUBSCRIBE_MATURE_FILTER"), function (tier) { return ({ tier: tier }); });
export var changeTier = createAction("".concat(actionKey, ".CHANGE_TIER"), function (currentTier, newTier) { return ({
    currentTier: currentTier,
    newTier: newTier,
}); });
export var pushChangeTierModal = function (currentTier, newTier, isDowngrade) {
    return pushModal(ModalType.TIER_CHANGE, {
        params: { currentTier: currentTier, newTier: newTier, isDowngrade: isDowngrade },
    });
};
//# sourceMappingURL=actions.js.map